import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/exclamation_point.png'
import _imports_1 from '@/assets/img/logo.svg'


const _hoisted_1 = { class: "welcomePage" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "swiper-slide loginBg1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "swiper-slide loginBg2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "swiper-slide loginBg3" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "notLoggedInMessage"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "contentContainer bubblesBg" }
const _hoisted_8 = { class: "text-center w-100" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "logo"
}, null, -1)
const _hoisted_10 = { class: "mt-4 d-flex justify-content-center align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slides = _resolveComponent("swiper-slides")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_swiper_slides, {
      class: "welcomeBgImages",
      showPagination: false,
      arrow: false,
      loop: true,
      autoplay: true
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    (_ctx.$route.query.redirect)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", {
            class: "message text-center",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"]))
          }, [
            _hoisted_6,
            _createVNode(_component_localized_text, {
              localizedKey: "app_showNotLoggedInMessage",
              text: "Hai aperto un link, per visualizzare il contenuto esegui il login o registrati"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_localized_text, {
          localizedKey: "app_findYourCommunity",
          text: "Find your community!",
          class: "fs_24 white d-block mt-3 mb-4"
        }),
        _createVNode("button", {
          type: "button",
          class: "genericButton bgPurple w-100 mb-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navTo('login')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_login",
            text: "Login",
            class: "fs_14 white"
          })
        ]),
        _createVNode("button", {
          type: "button",
          class: "genericButton bgWhite w-100",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navTo('register')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_signUp",
            text: "Sign up",
            class: "fs_14 black"
          })
        ]),
        _createVNode("div", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
            return (_openBlock(), _createBlock("div", {
              class: ["me-3 pointer", {'op-3' : _ctx.selectedLanguage != lang }],
              key: lang,
              onClick: ($event: any) => (_ctx.setLanguage(lang))
            }, [
              _createVNode("img", {
                style: {"height":"45px"},
                src: './img/flags/' + lang + '.png'
              }, null, 8, ["src"])
            ], 10, ["onClick"]))
          }), 128))
        ])
      ])
    ])
  ]))
}